import React from 'react'
import useUserPreferences from 'app/hooks/useUserPreferences'
import { useMediaQuery } from '@mui/material'

type Props = {}

const useCardModalAlertMobile = (props: Props) => {
  const [open, setOpen] = React.useState(false)
  const { getPreference, updatePreference } = useUserPreferences({ name: 'alert-mobile' })
  const [dontShowAgain, setDontShowAgain] = React.useState(false);
  const isMediaMD = useMediaQuery((theme: any) => theme?.breakpoints?.up('sm'));

  React.useEffect(() => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const isTablet = /iPad|Tablet/i.test(navigator.userAgent); // Added tablet detection
    const shouldShowModal = isMobile && !isMediaMD && !isTablet && !getPreference('dismissed'); // Exclude tablets
    setOpen(shouldShowModal);
  }, []);

  const dismissModal = () => {
    if (dontShowAgain) {
      updatePreference('dismissed', true);
    }
    setOpen(false);
  };

  return {
    open,
    setOpen,
    dismissModal,
    dontShowAgain,
    setDontShowAgain,
  }
}

export default useCardModalAlertMobile